module.exports = __webpack_public_path__ + "static/img/loginbg.8dad36a8.jpg";